import moment from 'moment'

function totalFunction(endRange: string, pnlData?: any[]): string {
  if (!Array.isArray(pnlData)) return ''
  const item = pnlData.find((i) => String(i.endRange) === String(endRange))
  const amount = item?.average
  return amount !== undefined && amount !== null ? String(amount) : '0'
}

/**
 * Form 433-B English Mapping
 */
export const FORM_433B_CONFIG_ENG = (
  branch?: any,
  user?: any,
  pnlData?: any
): Record<string, any> => {
  const phone = String(branch?.phone || '').replace(/[()-]/g, '')
  const info = branch?.form_info || {}

  return {
    // Section 1: Business Information
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_1_1a[0]': branch?.businessName || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_3_1b[0]': branch?.businessAddress || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_5_1bCity[0]': branch?.city || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_6_1bstate[0]': branch?.state || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_7_1bZIP[0]': branch?.zip || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_9_1d_3digits[0]': phone.slice(0, 3) || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_10_1d_7digits[0]': phone ? phone.slice(-7) : '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_8_1c[0]': branch?.country || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_4_1bMailAdd[0]': info.mailingAddressB || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_11_1e[0]': info.typeOfBusinessB || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_12_1f[0]': info.businessWebsiteB || '',
    'topmostSubform[0].Page1[0].p1_13_2a[0]': branch?.ein || '',
    'topmostSubform[0].Page1[0].p1_16_2c[0]': info.dateIncorporated
      ? moment(info.dateIncorporated).format('MMDDYYYY')
      : '',
    'topmostSubform[0].Page1[0].p1_17_3a[0]': info.numberOfEmployees || '',
    'topmostSubform[0].Page1[0].p1_18_3b[0]': info.monthlyGrossPayroll || '',
    'topmostSubform[0].Page1[0].p1_19_3c[0]': info.taxDepositFrequency || '',

    // Checkboxes
    'topmostSubform[0].Page1[0].c1_1[0]': info.eftpsEnrolled === 'yes',
    'topmostSubform[0].Page1[0].c1_1[1]': info.eftpsEnrolled === 'no',
    'topmostSubform[0].Page1[0].c1_0_2b[0]': info.entityType === 'Partnership',
    'topmostSubform[0].Page1[0].c1_0_2b[1]': info.entityType === 'Corporation',
    'topmostSubform[0].Page1[0].c1_0_2b[3]': info.entityType === 'LlcCorp',
    'topmostSubform[0].Page1[0].c1_0_2b[4]': info.entityType === 'OtherLLC',
    'topmostSubform[0].Page1[0].c1_0_2b[2]': info.entityType === 'Other',
    'topmostSubform[0].Page1[0].p1_15_2bc[0]': info.llcMembersCount || '',
    'topmostSubform[0].Page1[0].p1_15_2b[0]': info.otherEntityText || '',

    // Section 5: Monthly Income / Expenses
    'topmostSubform[0].Page6[0].p6_01_Sec5[1]':branch.usesPOS==3,
    "topmostSubform[0].Page6[0].p6_01_Sec5[0]":branch.usesPOS!=3,
    'topmostSubform[0].Page6[0].TotalIncome[0].GrssMnthly25[0]': totalFunction('66990', pnlData),
    'topmostSubform[0].Page6[0].TotalIncome[0].GrossMnthly26[0]': totalFunction('69780', pnlData),
    'topmostSubform[0].Page6[0].TotalIncome[0].GrossMnthly27[0]': totalFunction('99280', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMntly38[0]': totalFunction('86990', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnthly39[0]': totalFunction('86490', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnhtly43[0]': totalFunction('84390', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnthly44[0]': totalFunction('84150', pnlData),
    'topmostSubform[0].Page6[0].TotalIncome[0].GrossMnthly28[0]': totalFunction('99890', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnthly36[1]': totalFunction('79980', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnthly40[0]': totalFunction('84850', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnthly41[0]': totalFunction('88840', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnthly42[0]': totalFunction('81320', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnthly45[0]':totalFunction('87990', pnlData)
  }
}

/**
 * Form 433-B Spanish Mapping
 */
export const FORM_433B_CONFIG_ESP = (
  branch?: any,
  user?: any,
  pnlData?: any
): Record<string, any> => {
  const phone = String(branch?.phone || '').replace(/[()-]/g, '')
  const info = branch?.form_info || {}

  return {
    // Section 1: Business Information
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_1_1a[0]': branch?.businessName || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_3_1b[0]': branch?.businessAddress || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_5_1bCity[0]': branch?.city || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_6_1bstate[0]': branch?.state || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_7_1bZIP[0]': branch?.zip || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_9_1d_3digits[0]': phone.slice(0, 3) || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_10_1d_7digits[0]': phone ? phone.slice(-7) : '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_8_1c[0]': branch?.country || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_4_1bMailAdd[0]': info.mailingAddressB || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_11_1e[0]': info.typeOfBusinessB || '',
    'topmostSubform[0].Page1[0].Line1a-f[0].p1_12_1f[0]': info.businessWebsiteB || '',
    'topmostSubform[0].Page1[0].p1_13_2a[0]': branch?.ein || '',
    'topmostSubform[0].Page1[0].p1_16_2c[1]': info.dateIncorporated
      ? moment(info.dateIncorporated).format('MMDDYYYY')
      : '',
    'topmostSubform[0].Page1[0].p1_17_3a[0]': info.numberOfEmployees || '',
    'topmostSubform[0].Page1[0].p1_18_3b[0]': info.monthlyGrossPayroll || '',
    'topmostSubform[0].Page1[0].p1_19_3c[0]': info.taxDepositFrequency || '',

    // Checkboxes
    'topmostSubform[0].Page1[0].c1_1[0]': info.eftpsEnrolled === 'yes',
    'topmostSubform[0].Page1[0].c1_1[1]': info.eftpsEnrolled === 'no',
    'topmostSubform[0].Page1[0].c1_0_2b[0]': info.entityType === 'Partnership',
    'topmostSubform[0].Page1[0].c1_0_2b[1]': info.entityType === 'Corporation',
    'topmostSubform[0].Page1[0].c1_0_2b[3]': info.entityType === 'LlcCorp',
    'topmostSubform[0].Page1[0].c1_0_2b[4]': info.entityType === 'OtherLLC',
    'topmostSubform[0].Page1[0].c1_0_2b[2]': info.entityType === 'Other',
    'topmostSubform[0].Page1[0].p1_15_2bc[0]': info.llcMembersCount || '',
    'topmostSubform[0].Page1[0].p1_15_2b[0]': info.otherEntityText || '',

    // Section 5: Monthly Income / Expenses
    'topmostSubform[0].Page6[0].p6_01_Sec5[1]':branch.usesPOS==3,
    'topmostSubform[0].Page6[0].p6_01_Sec5[0]':branch.usesPOS!=3,
    'topmostSubform[0].Page6[0].TotalIncome[0].GrssMnthly25[0]': totalFunction('66990', pnlData),
    'topmostSubform[0].Page6[0].TotalIncome[0].GrossMnthly26[0]': totalFunction('69780', pnlData),
    'topmostSubform[0].Page6[0].TotalIncome[0].GrossMnthly27[0]': totalFunction('99280', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMntly38[0]': totalFunction('86990', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnthly39[0]': totalFunction('86490', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnhtly43[0]': totalFunction('84390', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnthly44[0]': totalFunction('84150', pnlData),
    'topmostSubform[0].Page6[0].TotalIncome[0].GrossMnthly28[0]': totalFunction('99890', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnthly36[1]': totalFunction('79980', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnthly40[0]': totalFunction('84850', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnthly41[0]': totalFunction('88840', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnthly42[0]': totalFunction('81320', pnlData),
    'topmostSubform[0].Page6[0].TotalExpenses[0].ActlMnthly45[0]':totalFunction('87990', pnlData)
  }
}

/**
 * Pre-Fill Logic dedicated to Form 433-B
 */
export const preFillForm433b = (
  existingFields: Record<string, any> = {},
  branchData?: Record<string, any>,
  userData?: Record<string, any>,
  pnlData?: any,
  overwritePnlFields: boolean = false,
  lang?:any
): Record<string, any> => {
  const isSpanish = lang === 'es' || lang?.startsWith('es-')
  const getFormFallback = isSpanish ? FORM_433B_CONFIG_ESP : FORM_433B_CONFIG_ENG

  const formFallbacks = getFormFallback(branchData, userData, pnlData)
  const result: Record<string, any> = { ...existingFields }

  Object.entries(formFallbacks).forEach(([fieldKey, fallbackValue]) => {
    const pdfValue = existingFields[fieldKey]
    const isSection5Field = fieldKey.includes('Page6[0]')

    const hasPdfValue =
      pdfValue !== undefined &&
      pdfValue !== null &&
      pdfValue !== '' &&
      pdfValue !== false

    if (overwritePnlFields && isSection5Field) {
      result[fieldKey] = fallbackValue !== undefined && fallbackValue !== null ? fallbackValue : ''
    } else if (hasPdfValue) {
      result[fieldKey] = pdfValue
    } else if (fallbackValue !== undefined && fallbackValue !== null && fallbackValue !== '') {
      result[fieldKey] = fallbackValue
    } else {
      result[fieldKey] = typeof fallbackValue === 'boolean' ? false : ''
    }
  })

  return result
}
